export default {
  name: 'marking--unitSerialNumberType',
};
